(function (Drupal) {
  Drupal.behaviors.Viewdayhealtqueensofia = {
    attach: function (context, settings) {
      const homeCategory = document.querySelector(".home-category")
      const reina = document.querySelector('.home-category.reina', context);
      if(reina) {
        document.body.classList.add('custom-portal-reina-sofia');
      }

      if (document.body.classList.contains('page-view-day-healt') && homeCategory) {
        const titlePage = document.querySelector('.view-day-healt .view-header', context);
        const containerBack = document.querySelector('#block-subtheme-keralty-back-2', context);
        if (titlePage) {
          titlePage.classList.add("d-none");
        }
        if (titlePage && containerBack && !containerBack.classList.contains("header-inserted")) {
          containerBack.classList.add("Viewdayhealtqueensofia", "header-inserted");
          containerBack.insertBefore(titlePage, containerBack.firstChild);
          titlePage.classList.remove("d-none");
        }
      }
    }
  };
})(Drupal);

